<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title font">Carga masiva de aportaciones de DI/FS</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <form class="form-modal py-3" [formGroup]="formGroup">
      <div class="row-fields">
        <div class="col-sm flex-grow-1">
          <label for="poseedor">Adherido </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="adherido" id="adherido" type="text" >
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row-fields" >
          <label for="documento">Aportación DI <span class="oblig">*</span></label>
      </div>
      <div class="row-fields" >
        <div class="col-sm flex-grow-1">
          <div class="custom-mat-field">
            <div class="attach">
                <input #file type="file" multiple (change)="file && file.files && attachAdjunto(file.files)" class="hide"
                  id="adjuntar" name="adjuntar">
                <button type="button" class="btn btn-outline-primary" (click)="file.click()">Seleccionar fichero</button>
              <div>
                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="documento != undefined"
                  class="centrar archivo">
                  <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{documento.name}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-sm flex-grow-0">
          <button type="button" class="btn btn-primary" data-toggle="modal" (click)="addFile()" [disabled]="!documento">Añadir</button>
        </div>-->
      </div>
      
      <div class="row-fields">
        <div class="col-sm flex-grow-1">
          <mat-card class="upload-area"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            [class.dragging]="isDragging">
            <input #fileInput type="file" multiple (change)="onFileSelected($event)" style="display: none;" />
            <p>O arrastra y suelta los archivos aquí</p>
            <div *ngIf="files.length > 0">
              <h3>Archivos adjuntados:</h3>
              <ul>
                <li *ngFor="let file of files">{{ file.name }}</li>
              </ul>
            </div>
          </mat-card>
        </div>

      </div>
    </form>

    <div class="datatable-container table-responsive">
      <lib-ge-table [headArray]="headArray" [gridArray]="grid" (actionButton)="action($event)">
      </lib-ge-table>
    </div>

  </div>
  <div class="modal-footer actions">
    <div class="note">* Campos Obligatorios</div>
    <div class="button-group">
      <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal"
          aria-label="Close">Volver</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          >Cargar masivamente aportaciones DI/FS</button>
    </div>
  </div>
</div>
